import { API } from "../../utils/API";

const get = (params) => {
	return API.get("protesto", { params }).then((res) => res.data);
};

export { get };
